import styled from "styled-components";
import { carouselSectionPadding } from "../CarouselSection/styled";

export const Section = styled.div`
    ${carouselSectionPadding}
`;
